import { useState, useCallback, useEffect } from 'react'
import taskService from '../services/tasks/taskService'

const PAGE_SIZE = 10

export default function useTasks() {
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [filters, setFilters] = useState({
    status: '',
    name: '',
    page: 1,
  })

  const fetchTasks = useCallback(async () => {
    setLoading(true)
    try {
      const params = {
        limit: PAGE_SIZE,
        offset: (filters.page - 1) * PAGE_SIZE,
      }
      if (filters.status) params.status = filters.status
      if (filters.name) params.name = filters.name

      const response = await taskService.getMyAssignedTasks(params)
      const raw = response.data
      const list = Array.isArray(raw) ? raw : Array.isArray(raw.data) ? raw.data : Array.isArray(raw.results) ? raw.results : []
      setTasks(list)
      setTotal(raw.count || list.length || 0)
    } catch {
      setTasks([])
    } finally {
      setLoading(false)
    }
  }, [filters])

  useEffect(() => {
    fetchTasks()
  }, [fetchTasks])

  const setPage = useCallback((page) => {
    setFilters((prev) => ({ ...prev, page }))
  }, [])

  const setStatus = useCallback((status) => {
    setFilters((prev) => ({ ...prev, status, page: 1 }))
  }, [])

  const setSearch = useCallback((name) => {
    setFilters((prev) => ({ ...prev, name, page: 1 }))
  }, [])

  const refresh = useCallback(() => {
    fetchTasks()
  }, [fetchTasks])

  return {
    tasks,
    loading,
    total,
    filters,
    pageSize: PAGE_SIZE,
    setPage,
    setStatus,
    setSearch,
    refresh,
  }
}
